import PopupModalComponent from './PopupModal'

export default PopupModalComponent